module.exports = __webpack_public_path__ + "static/img/service1.f62f597.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/official/service1.jpg
// module id = Ac0G
// module chunks = 0